// extracted by mini-css-extract-plugin
module.exports = {"formProyects":"styles_formProyects__3ky7K","proyects":"styles_proyects__3ewnm"};